import React from "react";
import "./style.scss"
import { useState } from "react";
import { useEffect } from "react";
import "./style.scss"
import { Button } from "@mui/material";
import { getCategories } from "services/user/bookService";
import { BsPencil } from "react-icons/bs";
import { RiDeleteBin6Line } from "react-icons/ri";
import { Formatter } from "utils/formatter";
import Pagination from '@mui/material/Pagination';
import { Link } from "react-router-dom";
import Top5CategoriesChart from "component/admin/barChart";
import { PieChart } from "@mui/x-charts";
import { FaBasketShopping} from "react-icons/fa6";
import { TbCategoryPlus } from "react-icons/tb";
import { addCategory, updateCategory, deleteCategory, getHiddenCategories, unhideCategory, getTop5BestSellerCate, getUnhiddenCategories } from "services/admin/categoryService";
import { IoIosCloseCircle } from "react-icons/io";
import Swal from "sweetalert2";
import { FaRegEye, FaRegEyeSlash } from "react-icons/fa";
import { PacmanLoader } from "react-spinners";
import { introspective } from "services/tokenService";
import { getTotalOrders } from "services/admin/dashboardService";
import { Token } from "@mui/icons-material";

const CategoryList = () => {
    const [isLoading, setIsLoading] = useState(false);

    const [totalOrder, setTotalOrder] = useState(0); // lưu tổng lượt bán

    const [categories, setCategories] = useState([]);
    const [categoryAdd, setCategoryAdd] = useState("") // lưu tên thể loại cần được thêm
    const token = localStorage.getItem("token")
    // luuw thông tin của thể loại(id, name, ...) được chọn khi chọn sửa hoặc xoá
    const [categorySelect, setCategorySelect] = useState({id: null, name: ''});

    const [isHidden, setIsHidden] = useState(false)

    const [top5Categories, setTop5Categories] = useState()

    const [modal, setModal] = useState(false);
    const toggleModal = (category) => {
        if (category !== null) {
            setCategorySelect(category)
            setModal(!modal)
        }
        else {
            setModal(!modal)
        }
    }

    useEffect(() => {
        const fetchTotalOrder = async () => {
            const response = await getTotalOrders(token)
            if (response) {
                setTotalOrder(response.data)
            }
        }
        fetchTotalOrder()
    }, [token])

    const [categoryPermission, setCategoryPermission] = useState(""); // lưu xem có quyền qly thẻ  loại không
    
    useEffect(() => {
        const fetchPermissions = async () => {
            try {
                const response = await introspective(token);
                if (response.data) {
                    setCategoryPermission(response.data.permissions.some(permission => permission.id === 3)); // id 3 là thể loại
                }
            } 
            catch (error) {
                console.log("introspective failed:", error);
            } 
        };

        fetchPermissions();

    }, [token]);

    // categories
    const fetchCategories = async() => {
        setIsLoading(true)
        try {
            if (!isHidden) {
                const response = await getUnhiddenCategories(token);
                setCategories(response.data);
            }
            else {
                const response = await getHiddenCategories(token)
                setCategories(response.data)
            }
        } 
        catch (error) {
            console.error("Error fetching categories:", error);
        }
        finally {
            setIsLoading(false)
        }
    };
    useEffect(() => {
        fetchCategories();
    },[isHidden])
    
    const handleChangeAddCategory = (e) => {
        setCategoryAdd(e.target.value)
    } 

    const handleAddCategory = async () => {
        setIsLoading(true)
        try {
            const response = await addCategory (token, categoryAdd)
            if (response.data.message === "Category has been created!") {
                Swal.fire({
                    title: "Thêm thành công!",
                    text: `Thể loại "${categoryAdd}" đã được thêm!.`,
                    icon: "success"
                });
            }
            else if (response.data.message === "Category existed!"){
                Swal.fire({
                    title: "Có lỗi xảy ra!",
                    text: `Thể loại "${categoryAdd}" đã tồn tại (có thể bị ẩn).`,
                    icon: "error"
                });
            }
            else {
                console.log(response.status)
                Swal.fire({
                    title: "Có lỗi xảy ra!",
                    text: "Không thể thêm thể loại. Vui lòng kiểm tra lại thông tin.",
                    icon: "error"
                });
            }
            await fetchCategories();
        } 
        catch (error) {
            console.log ("Add category: ", error)
            Swal.fire({
                title: "Có lỗi xảy ra!",
                text: "Không thể thêm thể loại. Vui lòng kiểm tra lại thông tin.",
                icon: "error"
            })
        }
        finally {
            setIsLoading(false)
        }
    }

    const handleUpdateCategory = async () => {
        setIsLoading(true)
        try {
            const response = await updateCategory(token, categorySelect)
            toggleModal(null);
            if (response.data.message === "Category has been updated!") {
                Swal.fire({
                    title: "Cập nhật thành công!",
                    text: `Thể loại đã được đổi tên thành "${categorySelect.name}"!.`,
                    icon: "success"
                });
            }
            else {
                Swal.fire({
                    title: "Có lỗi xảy ra!",
                    text: "Chỉnh sửa thể loại thất bại. Vui lòng kiểm tra lại thông tin.",
                    icon: "error"
                });
            }
            await fetchCategories();
        } 
        catch (error) {
            console.log("Update category: ", error)
            Swal.fire({
                title: "Có lỗi xảy ra!",
                text: "Chỉnh sửa thể loại thất bại. Vui lòng kiểm tra lại thông tin.",
                icon: "error"
            })
        }
        finally {
            setIsLoading(false)
        }
    }

    const handleDeleteCategory = async (category) => {
        const result = await Swal.fire({
            title: "Bạn chắc chắn muốn xoá?",
            text: `Xác nhận sẽ xoá thể loại "${category.name}"!`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Xác nhận xoá!",
            cancelButtonText: "Huỷ"
        });
        
        if (result.isConfirmed) {
            setIsLoading(true)
            try {
                const response = await deleteCategory(token, category.id);
                if (response.data.message === "Category has been hidden!") {
                    Swal.fire({
                        title: "Xoá thành công!",
                        text: `Thể loại "${category.name}" đã được xoá.`,
                        icon: "success"
                    });
                }
                else {
                    Swal.fire({
                        title: "Có lỗi xảy ra!",
                        text: "Xoá thể loại thất bại. Vui lòng kiểm tra lại thông tin.",
                        icon: "error"
                    });
                }
                await fetchCategories();
            } 
            catch (error) {
                console.log("Delete category", error)
                Swal.fire({
                    title: "Có lỗi xảy ra!",
                    text: "Xoá thể loại thất bại. Vui lòng kiểm tra lại thông tin.",
                    icon: "error"
                });
            }
            finally {
                setIsLoading(false)
            }
        }
    }

    const handleUnhideCategory = async (category) => {
        const result = await Swal.fire({
            title: "Bạn có muốn hiển thị thể loại?",
            text: `Xác nhận sẽ hiển thị lại thể loại "${category.name}"!`,
            icon: "info",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Xác nhận!",
            cancelButtonText: "Huỷ"
        });
        
        if (result.isConfirmed) {
            setIsLoading(true)
            try {
                const response = await unhideCategory(token, category.id);
                if (response.data.message === "Category is unhidden!") {
                    Swal.fire({
                        title: "Thành công!",
                        text: `Thể loại "${category.name}" đã được hiển thị.`,
                        icon: "success"
                    });
                }
                else {
                    Swal.fire({
                        title: "Có lỗi xảy ra!",
                        text: "Hiển thị lại thể loại thất bại. Vui lòng kiểm tra lại thông tin.",
                        icon: "error"
                    });
                }
                await fetchCategories();
            } 
            catch (error) {
                console.log("Unhide category", error)
                Swal.fire({
                    title: "Có lỗi xảy ra!",
                        text: "Hiển thị lại thể loại thất bại. Vui lòng kiểm tra lại thông tin.",
                    icon: "error"
                });
            }
            finally {
                setIsLoading(false)
            }
        }
    }

    const handleHidden = () => {
        setIsHidden(!isHidden)
    }

    useEffect(() => {
        const fetchTop5BestSellerCate = async () => {
            const response = await getTop5BestSellerCate(token)
            if (response && response.data ) {
                setTop5Categories(response.data.map(item => (
                    {
                        category: item.categoryName,
                        sales: +item.soldQuantity
                    }
                )))
            }
        }
        fetchTop5BestSellerCate();
    }, [token])

    return (
        <div className="CategoryList">
            <div className="dashboardBoxWrapper d-flex mt-5">
                <div className="dashboardBox col">
                    <div className="row w-100 m-0">
                        <div className="col-lg-4 d-flex align-items-center">
                            <div className="avatar-md rounded color3">
                                <TbCategoryPlus />
                            </div>
                        </div>
                        <div className="col-lg-8 text-end flex-col align-items-center pe-3">
                            <p>Tổng thể loại</p>
                            <h3 className="m-0">{categories.length}</h3>
                        </div>
                    </div>
                </div>

                <div className="dashboardBox col">
                    <div className="row w-100 m-0">
                        <div className="col-lg-4 d-flex align-items-center">
                            <div className="avatar-md rounded color2">
                                <FaBasketShopping/>
                            </div>
                        </div>  
                        <div className="col-lg-8 text-end flex-col align-items-center pe-3">
                            <p>Tổng lượt bán</p>
                            <h3 className="m-0">{totalOrder}</h3>
                        </div>
                    </div>
                </div>
            </div>
            
            <div className="card border-0 p-4 mt-5">
                <h5>Top 5 thể loại có nhiều lượt bán</h5>
                <hr />
                {top5Categories && (
                    <Top5CategoriesChart className="barChart" top5Categories={top5Categories}/>
                )}
                {/* <PieChart
                    series={[
                        {
                            data: bookSalesData,
                            highlightScope: { fade: 'global', highlight: 'item' },
                            // faded: { innerRadius: 30, additionalRadius: -30, color: 'gray' },
                        },
                    ]}
                    slotProps={{
                        legend: {
                          direction: 'column',
                          position: { vertical: 'middle', horizontal: 'right' },
                          padding: 30,
                        },
                      }}
                    height={200}
                /> */}
            </div>
            <div className="card border-0 p-4 mt-5 mb-5">
                <div className="headCard d-flex">
                    <h5>Thể loại</h5>
                </div>
                <hr />

                <div className="addCategory d-flex">
                    <input onChange={handleChangeAddCategory} type="text" placeholder="Tên thể loại"/>
                    <Button 
                        className="addCate-btn" 
                        onClick={() => {
                            if(!categoryPermission) {
                                Swal.fire({
                                    title: "Không có quyền!",
                                    text: "Bạn không có quyền thêm thể loại.",
                                    icon: "error"
                                });
                            }
                            else {
                                handleAddCategory()
                            }
                        }}
                    >
                        Thêm mới thể loại
                    </Button>
                    <Button onClick={handleHidden} className="eyeHidden ms-auto" color="secondary">{isHidden ? <FaRegEyeSlash/> : <FaRegEye/>}</Button>
                </div>

                <div className="table-responsive mt-3">
                    <table className="table table-bordered v-align">
                        <thead className="thead-dark">
                            <tr>
                                <th>ID</th>
                                <th>THỂ LOẠI</th>
                                <th>SỐ LƯỢNG SÁCH</th>
                                <th>ĐƠN HÀNG</th>
                                <th>DOANH THU</th>
                                <th>ACTION</th>
                            </tr>
                        </thead>

                        <tbody>
                            {categories && categories.length > 0 ? (
                                categories.sort((a, b) => a.id - b.id)
                                    .map((category, index) => (
                                    <tr key={category.id}>
                                        <td>{index+1}</td>
                                        <td>
                                            <div className="d-flex productBox">
                                                <h6>{category.name}</h6>
                                            </div>
                                        </td>
                                        <td>{category.quantity}</td>
                                        <td>{category.soldQuantity}</td>
                                        <td>
                                            <span className="new text-danger">{Formatter(category.revenue)}</span>
                                        </td>
                                        <td>
                                            <div className="actions d-flex align-items-center justify-content-center">
                                                {!isHidden ? (
                                                    <>
                                                        <Button 
                                                            onClick={() => {
                                                                if(!categoryPermission) {
                                                                    Swal.fire({
                                                                        title: "Không có quyền!",
                                                                        text: "Bạn không có quyền sửa thông tin thể loại.",
                                                                        icon: "error"
                                                                    });
                                                                }
                                                                else {
                                                                    toggleModal(category)
                                                                }
                                                            }} 
                                                            className="secondary"
                                                            color="secondary"
                                                            >
                                                            <BsPencil />
                                                        </Button>

                                                        <Button onClick={() => {
                                                            if(!categoryPermission) {
                                                                Swal.fire({
                                                                    title: "Không có quyền!",
                                                                    text: "Bạn không có quyền xoá thể loại.",
                                                                    icon: "error"
                                                                });
                                                            }
                                                            else {
                                                                handleDeleteCategory(category)
                                                            }
                                                        }} className="error" color="error"> <RiDeleteBin6Line /></Button>
                                                    </>
                                                ) : (
                                                    <Button onClick={() => {
                                                        if(!categoryPermission) {
                                                            Swal.fire({
                                                                title: "Không có quyền!",
                                                                text: "Bạn không có quyền hiển thị lại thể loại.",
                                                                icon: "error"
                                                            });
                                                        }
                                                        else {
                                                            handleUnhideCategory(category)
                                                        }
                                                    }} className="secondary" color="secondary"><FaRegEyeSlash /></Button>
                                                )}
                                                
                                            </div>

                                            {modal && categorySelect && (
                                                <div className="modal">
                                                    <div className="overlay1">
                                                        <div className="modal-content1">
                                                            <div className="d-flex">
                                                                <h5>Cập nhật tên thể loại</h5>
                                                                <IoIosCloseCircle className="close-modal ms-auto" onClick={() => toggleModal(null)}/>                       
                                                            </div>
                                                        
                                                            <div className="input-container" >
                                                                <input
                                                                    type="text"
                                                                    placeholder="Enter a value"
                                                                    value={categorySelect.name}
                                                                    onChange={(e) => setCategorySelect({...categorySelect, name: e.target.value })}
                                                                />
                                                            </div>
                                                            <Button onClick={handleUpdateCategory} className="add-btn">
                                                                Xác nhận
                                                            </Button>
                                                        </div>
                                                    </div>
                                                </div>
                                            )} 
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr> 

                                </tr>
                            )}
                        </tbody>
                    </table>

                    <div className="d-flex tableFooter">
                        <Pagination className="ms-auto" count={1} color="secondary" />
                    </div>
                </div>
            </div>

            {isLoading && (
                <div className="modal">
                    <div className="overlay_loading">
                        <div className="modal-content_loading">
                            <div className="d-flex">
                            <PacmanLoader color="#5e2e86"/>
                            </div>
                        </div>
                    </div>
                </div>
            )} 
        </div>
    )
}


export default CategoryList;
